import {makeObservable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {DateTimeModel} from '../Date/DateTime.model';
import type {PaymentModel} from '../Payment/Payment.model';
import type {PriceModel} from '../Price/Price.model';

import {BaseModel} from '../../../core/domain/Base/Base.model';

const ModelName = 'RefundModel';

export class RefundModel extends BaseModel {
  amount: PriceModel;
  createdDate: DateTimeModel;
  description: string;
  payment: Nullable<PaymentModel>;
  processing: RefundModel.Processing;
  refundedAmount: PriceModel;
  refundedDate: Nullable<DateTimeModel>;
  refundPayment: Nullable<PaymentModel>;
  status: RefundModel.Status;
  updatedDate: DateTimeModel;
  vendorPaymentId: Nullable<string>;
  vendorRefundId: Nullable<string>;

  constructor(props: RefundModel.Props) {
    super(props);

    Object.assign(this, props);

    makeObservable(this, BaseModel.mobxAnnotationFactory(props));
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace RefundModel {
  export enum Processing {
    EXTERNAL = 'external',
    INTERNAL = 'internal',
  }

  export enum Status {
    COMPLETE = 'complete',
    FAILED = 'failed',
    IN_PROGRESS = 'in_progress',
    PENDING = 'pending',
    REVERSED = 'reversed',
  }

  export type Props = BaseModel.ModelToProps<RefundModel>;

  export const minRefundAmount = 50;
}
